export enum ChainListId {
    AAVEGOTCHI_TESTNET = 202103,
    APTOS = 1,
    APTOS_TESTNET = 2,
    APTOS_TESTNET_SANDBOX = 3,
    ARBITRUM = 42161,
    ARBITRUM_GOERLI = 421613,
    ARBITRUM_GOERLI_SANDBOX = 421613,
    ARBITRUM_RINKEBY = 421611,
    ARBITRUM_RINKEBY_SANDBOX = 421611,
    ARCANA_TESTNET = 40404,
    ARCANA_TESTNET_SANDBOX = 40404,
    ASTAR = 592,
    ASTAR_TESTNET = 81,
    AURORA = 1313161554,
    AURORA_TESTNET = 1313161555,
    AURORA_TESTNET_SANDBOX = 1313161555,
    AVALANCHE = 43114,
    BASE = 8453,
    BASE_TESTNET = 84531,
    BEAM = 4337,
    BEAM_TESTNET = 13337,
    BOBA = 288,
    BOBA_TESTNET = 28,
    BOBA_TESTNET_SANDBOX = 28,
    BSC = 56,
    BSC_TESTNET = 97,
    BSC_TESTNET_SANDBOX = 97,
    CANTO = 7700,
    CANTO_TESTNET = 740,
    CASTLECRUSH_TESTNET = 31416,
    CASTLECRUSH_TESTNET_SANDBOX = 31416,
    CELO = 42220,
    CELO_TESTNET = 44787,
    CELO_TESTNET_SANDBOX = 44787,
    CONFLUX = 1030,
    CONFLUX_TESTNET = 71,
    COREDAO = 1116,
    COREDAO_TESTNET = 1115,
    DEXALOT = 432204,
    DEXALOT_TESTNET = 432201,
    DEXALOT_TESTNET_SANDBOX = 432201,
    DFK = 53935,
    DFK_TESTNET = 335,
    DFK_TESTNET_SANDBOX = 335,
    DOS = 7979,
    DOS_TESTNET = 3939,
    ETHEREUM = 1,
    EON = 7332,
    EON_TESTNET = 1663,
    FANTOM = 250,
    FANTOM_TESTNET = 4002,
    FANTOM_TESTNET_SANDBOX = 4002,
    FRAME_TESTNET = 68840142,
    FUJI = 43113,
    FUJI_SANDBOX = 43113,
    FUSE = 122,
    GNOSIS = 100,
    GNOSIS_TESTNET = 300,
    GNOSIS_TESTNET_SANDBOX = 300,
    GOERLI = 5,
    GOERLI_MAINNET = 5,
    GOERLI_SANDBOX = 5,
    HARMONY = 1666600000,
    HARMONY_TESTNET = 1666700000,
    HARMONY_TESTNET_SANDBOX = 1666700000,
    HOLESKY = 17000,
    HOLESKY_TESTNET = 17000,
    HUBBLE = 321123,
    HUBBLE_TESTNET = 321123,
    IDEX_TESTNET = 23432,
    KAVA = 2222,
    KAVA_TESTNET = 2221,
    KIWI_TESTNET = 2037,
    KLAYTN = 8217,
    KLAYTN_TESTNET = 1001,
    KOVAN = 42,
    KOVAN_SANDBOX = 42,
    LIF3_TESTNET = 1811,
    LOOT = 5151706,
    LOOT_TESTNET = 9088912,
    MANTA_TESTNET = 3441005,
    MANTLE = 5000,
    MANTLE_TESTNET = 5001,
    METER = 82,
    METER_TESTNET = 83,
    METIS = 1088,
    METIS_TESTNET = 599,
    MOONBEAM = 1284,
    MOONBEAM_TESTNET = 1287,
    MOONBEAM_TESTNET_SANDBOX = 1287,
    MOONRIVER = 1285,
    MUMBAI = 80001,
    MUMBAI_SANDBOX = 80001,
    NOVA = 42170,
    ODA_TESTNET = 25,
    OKX = 66,
    OPBNB = 204,
    OPBNB_TESTNET = 5611,
    OPTIMISM = 10,
    OPTIMISM_GOERLI = 420,
    OPTIMISM_GOERLI_SANDBOX = 420,
    OPTIMISM_KOVAN = 69,
    OPTIMISM_KOVAN_SANDBOX = 69,
    ORDERLY = 291,
    ORDERLY_TESTNET = 4460,
    PGN_TESTNET = 58008,
    POLYGON = 137,
    POLYGONCDK_TESTNET = 686669576,
    PORTAL_TESTNET = 808,
    PORTAL_TESTNET_SANDBOX = 808,
    PGJJTK_TESTNET = 88018,
    RINKEBY = 4,
    RINKEBY_SANDBOX = 4,
    SCROLL = 534352,
    SCROLL_TESTNET = 534351,
    SEPOLIA = 11155111,
    SHIMMER_TESTNET = 1072,
    SHRAPNEL = 2044,
    SPRUCE_TESTNET = 424242,
    SWIMMER = 73772,
    SWIMMER_TESTNET = 73771,
    SWIMMER_TESTNET_SANDBOX = 73771,
    TELOS = 40,
    TELOS_TESTNET = 41,
    TENET = 1559,
    TENET_TESTNET = 155,
    TOMO = 88,
    TOMO_TESTNET = 89,
    XPLA = 37,
    XPLA_TESTNET = 47,
    ZKATANA_TESTNET = 1261120,
    ZKCONSENSYS = 59144,
    ZKCONSENSYS_TESTNET = 59140,
    ZKPOLYGON = 1101,
    ZKPOLYGON_TESTNET = 1442,
    ZKSYNC = 324,
    ZKSYNC_TESTNET = 280,
    ZORA = 7777777,
    ZORA_TESTNET = 999
}